import React from 'react';
import { Box, CardContent, Chip, Typography, useTheme } from '@mui/material';
import StyledCard from './ui/Styled';
import type { DetectionResult } from '../services/api';
import { getSeverityStyles } from './ui/severity';

interface LatestCaptureCardProps {
  detections: DetectionResult[];
}

export default function LatestCaptureCard({ detections }: LatestCaptureCardProps) {
  if (detections.length === 0) return null;

  const theme = useTheme();

  return (
    <StyledCard data-testid="latest-capture-card" sx={{ border: `1px solid ${theme.palette.primary.main}`, mb: 2 }}>
      
      <CardContent>
        <Typography
          sx={{
            color: 'primary.main',
            fontWeight: 'bold',
            mb: 1.5,
            fontSize: 13,
            textTransform: 'uppercase',
            letterSpacing: 0.5,
          }}
        >
          Latest Capture · {detections.length} detection{detections.length === 1 ? '' : 's'}
        </Typography>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
          {detections.map((d, i) => (
            <Box
              key={i}
              data-testid="latest-detection-row"
              sx={{
                display: 'flex',
                alignItems: 'flex-start',
                gap: 1,
                p: 1,
                bgcolor: 'background.default',
                borderRadius: 1,
                borderLeft: `3px solid ${getSeverityStyles(theme, d.severity).color}`,
              }}
            >
              <Box sx={{ flex: 1, minWidth: 0 }}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 0.5 }}>
                  <Typography sx={{ color: 'text.primary', fontWeight: 700, fontSize: 12 }}>
                    {d.defect_type.toUpperCase()}
                  </Typography>
                  <Chip
                    label={d.severity}
                    size="small"
                    sx={{
                      bgcolor: getSeverityStyles(theme, d.severity).bg,
                      color: getSeverityStyles(theme, d.severity).color,
                      fontWeight: 700,
                      fontSize: 10,
                      height: 18,
                    }}
                  />
                  <Typography sx={{ color: 'text.secondary', fontSize: 11, ml: 'auto' }}>
                    {Math.round(d.confidence * 100)}%
                  </Typography>
                </Box>
                <Typography sx={{ color: 'text.secondary', fontSize: 11 }}>{d.description}</Typography>
              </Box>
            </Box>
          ))}
        </Box>
      </CardContent>
    </StyledCard>
  );
}
